// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"u5-z","colorTextValue":"v5-z","swatches":"w5-z","collapseLink":"x5-z","isCollapsed":"y5-z","dropdown":"z5-z","disabled":"A5-z"};